<ad-title-bar *ngIf="!isSnow" [title]="dashboardMainHeadingString"></ad-title-bar>

<div *ngIf="dashbordWarningMessage" class="warning-container container text-center mt-5 my-2"  >
  <ngb-alert
  dfInsertAlertIcon
    class="d-flex df-alert-sm mb-0 "
    [dismissible]="false"
  >
  <span class="me-5 pe-3">{{ dashboardWarningString }}</span>
  </ngb-alert>
</div>

<div class="container px-lg-10 px-md-10">
  <div class="dashboard-heading" *ngIf="officeOptions$ | async as items">
    <div class="row">
      <div class="offices-container col-md-6 ms-auto">
        <label class="col-lg-8 col-md-6" for="agencies">{{ dashboardOptionsAgenciesString }}</label>
        <div class="col-lg-4 col-md-6">
          <ng-select
            id="agencies"
            [items]="items"
            [searchable]="false"
            [clearable]="false"
            class="dashboard-select"
            [(ngModel)]="office"
            (change)="updateState()"
            bindValue="value"
          >
            <ng-template ng-option-tmp let-item="item">
              <span class="ng-option-label" [innerText]="(!item.value && item.label) || item.label"></span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span class="ng-value-label" [innerText]="(!item.value && item.label) || item.label"></span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
  </div>
  <app-dashboard-filters></app-dashboard-filters>
  <div class="row px-lg-8 px-md-8">
    <div class="col-xl-8">
      <app-dashboard-main></app-dashboard-main>
    </div>
    <div class="col-xl-4">
      <app-dashboard-right [dm]="isDecisionMaker"></app-dashboard-right>
    </div>
  </div>
</div>
